import {
  SET_INTENTS_LOADING,
  SET_INTENTS_ERROR,
  FETCH_INTENTS_SUCCESS,
} from '../Actions/AI/type';

const initialState = {
  loading: false,
  error: null,
  byDomain: {
    // [domain]: { items: [{key, description}], fetchedAt: number }
  },
};

const intentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INTENTS_LOADING:
      return { ...state, loading: true, error: null };
    case SET_INTENTS_ERROR:
      return { ...state, loading: false, error: action.payload };
    case FETCH_INTENTS_SUCCESS: {
      const { domain, items, fetchedAt } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        byDomain: {
          ...state.byDomain,
          [domain]: { items, fetchedAt },
        },
      };
    }
    default:
      return state;
  }
};

export default intentsReducer;
